import seriveFactory from './service';
import { Notification } from 'element-ui';
const API = seriveFactory({
  baseURL: `${window._env_.VUE_APP_REQUEST_ADDRESS}/channelRebateAuthority/`,
  withCredentials: true,
  headers: {
    'Content-Type': 'application/json', // application/x-www-form-urlencoded , multipart/form-data
    sysId: 'c0c73417cf58cb87e146a78f6e44ef44',
    // sysId: '5ff02fb805683292b553e989d41e7eb5',
    timeOut: new Date().getTime(),
    sid_login: localStorage.getItem('sidLogin') && JSON.parse(localStorage.getItem('sidLogin') || '')
  }
}, function (json, error) {
  Notification.error({
    message: json.error || json.err || '请求服务器失败'
  });
});
export default API;
